import { render, staticRenderFns } from "./SubAccountSettings.vue?vue&type=template&id=6e88c24e&scoped=true"
import script from "./SubAccountSettings.vue?vue&type=script&lang=js"
export * from "./SubAccountSettings.vue?vue&type=script&lang=js"
import style0 from "./SubAccountSettings.vue?vue&type=style&index=0&id=6e88c24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e88c24e",
  null
  
)

export default component.exports